import { AccessRequestOutcome } from "../../../incidentLog/IncidentLogDialog.types.ts";

// Only a partial or refused access leaves the data subject something to be told why and to complain about, so the
// fields that follow up on the outcome are kept for those two answers alone.
export function isAccessRestricted(outcome: AccessRequestOutcome | null | undefined) {
    return outcome === AccessRequestOutcome.PartialAccess || outcome === AccessRequestOutcome.Refused;
}

// The template editor preview shows every field so the whole template can be reviewed, even the ones that stay
// hidden until the access is known to be restricted.
export function showsWhenAccessIsRestricted(outcome: AccessRequestOutcome | null | undefined, isPreview: boolean) {
    return isPreview || isAccessRestricted(outcome);
}

// With no personal data found there is nothing to hand over, so asking whether a copy was provided makes no sense.
export function hasPersonalDataToCopy(outcome: AccessRequestOutcome | null | undefined) {
    return outcome !== AccessRequestOutcome.NoPersonalDataFound;
}

export function showsCopyOfPersonalDataProvided(outcome: AccessRequestOutcome | null | undefined, isPreview: boolean) {
    return isPreview || hasPersonalDataToCopy(outcome);
}
